/* Size Chart system: unit switching (in/cm), tabs, product modal. Vanilla JS, no deps. v2 (opens the tab matching the selected Style) */
(function () {
  'use strict';

  const CM_PER_INCH = 2.54;

  function formatNumber(value) {
    const rounded = Math.round(value * 10) / 10;
    return rounded % 1 === 0 ? String(Math.round(rounded)) : rounded.toFixed(1);
  }

  /* <size-chart-widget> — wraps one or more charts plus an INCH/CM switcher. */
  class SizeChartWidget extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-sc-num]').forEach((cell) => {
        if (!cell.hasAttribute('data-in')) {
          cell.setAttribute('data-in', cell.textContent.trim());
        }
      });
      this.addEventListener('click', (event) => {
        const unitButton = event.target.closest('[data-sc-set-unit]');
        if (unitButton) {
          this.setUnit(unitButton.getAttribute('data-sc-set-unit'));
          return;
        }
        const tabButton = event.target.closest('[data-sc-tab]');
        if (tabButton) this.activateTab(tabButton);
      });
      this.setUnit(this.getAttribute('data-default-unit') === 'cm' ? 'cm' : 'in');
    }

    setUnit(unit) {
      this.querySelectorAll('[data-sc-num]').forEach((cell) => {
        const inches = parseFloat(cell.getAttribute('data-in'));
        if (Number.isNaN(inches)) return;
        cell.textContent = unit === 'cm' ? formatNumber(inches * CM_PER_INCH) : cell.getAttribute('data-in');
      });
      this.querySelectorAll('[data-sc-unit-suffix]').forEach((el) => {
        el.textContent = unit === 'cm' ? '(cm)' : '(in)';
      });
      this.querySelectorAll('[data-sc-set-unit]').forEach((button) => {
        button.setAttribute('aria-pressed', button.getAttribute('data-sc-set-unit') === unit ? 'true' : 'false');
      });
    }

    activateTab(button) {
      const container = button.closest('[role="tablist"]') || button.parentElement;
      container.querySelectorAll('[data-sc-tab]').forEach((tab) => {
        const active = tab === button;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        const panel = this.querySelector('#' + CSS.escape(tab.getAttribute('data-sc-tab')));
        if (panel) panel.hidden = !active;
      });
    }
  }
  if (!customElements.get('size-chart-widget')) {
    customElements.define('size-chart-widget', SizeChartWidget);
  }

  /* <size-chart-modal> — product page popup. */
  class SizeChartModal extends HTMLElement {
    connectedCallback() {
      this.opener = null;
      this.onKeydown = (event) => {
        if (event.key === 'Escape') this.close();
      };
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-sc-close]') || event.target.classList.contains('sc-modal__backdrop')) {
          this.close();
        }
      });
    }

    open(opener) {
      this.opener = opener || null;
      // Ancestors with transform/filter (e.g. scroll animations) break position:fixed,
      // so portal the modal to <body> before showing it.
      if (this.parentElement !== document.body) document.body.appendChild(this);
      this.setAttribute('open', '');
      document.body.classList.add('sc-modal-open');
      document.addEventListener('keydown', this.onKeydown);
      const closeButton = this.querySelector('[data-sc-close]');
      if (closeButton) closeButton.focus();
      this.syncTabToStyle();
    }

    /* Family products have a Style option (Men/Women/Kids/Baby/Youth/Toddler…). Open the size-group tab that
       matches the selected Style, so a shopper on "Kids" lands on the Kids table instead of Adult. */
    syncTabToStyle() {
      let style = '';
      const radio = document.querySelector('input[type="radio"][name^="Style-"]:checked');
      if (radio) {
        style = radio.value;
      } else {
        const select = document.querySelector('select[name="options[Style]"]');
        if (select) style = select.value;
      }
      if (!style) return;
      const widget = this.querySelector('size-chart-widget');
      if (!widget || typeof widget.activateTab !== 'function') return;
      const tabs = Array.from(widget.querySelectorAll('[data-sc-tab]'));
      if (tabs.length < 2) return;
      const wanted = style.trim().toLowerCase();
      const label = (tab) => tab.textContent.trim().toLowerCase();
      const isChild = /kid|baby|youth|toddler|infant|boy|girl/.test(wanted);
      let tab = tabs.find((t) => label(t) === wanted) || tabs.find((t) => wanted.includes(label(t)) || label(t).includes(wanted));
      if (!tab) {
        tab = isChild
          ? tabs.find((t) => /kid|youth|toddler|baby|child/.test(label(t))) || tabs.find((t) => !/adult|men|women/.test(label(t)))
          : tabs.find((t) => /adult/.test(label(t))) || tabs[0];
      }
      if (tab) widget.activateTab(tab);
    }

    close() {
      if (!this.hasAttribute('open')) return;
      this.removeAttribute('open');
      document.body.classList.remove('sc-modal-open');
      document.removeEventListener('keydown', this.onKeydown);
      if (this.opener) this.opener.focus();
    }
  }
  if (!customElements.get('size-chart-modal')) {
    customElements.define('size-chart-modal', SizeChartModal);
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-sc-open]');
    if (!opener) return;
    const modal = document.getElementById(opener.getAttribute('data-sc-open'));
    if (modal && typeof modal.open === 'function') {
      event.preventDefault();
      modal.open(opener);
    }
  });
})();
